export default {
  publicConfig: state => state.publicConfig,
  publicConfigVersion: state => state.publicConfigVersion,
  privateConfig: state => state.privateConfig,
  privateConfigVersion: state => state.privateConfigVersion,
  isCallingConfig: state => state.isCallingConfig,
  currencies: state => state.currencies,
  zohoPlans: state => state.zohoPlans
}
